import React from "react";
import { Skeleton } from "antd";
export default function LoadingFrame(props) {
  return props.loading ? (
    <Skeleton active style={{ minWidth: "550px" }} />
  ) : (
    props.children
  );
}
